/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plain_Text_Import_Source_Preview_LabelInputs */

const en_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source Preview`)
};

const fr_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apercu de la source`)
};

const de_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quellvorschau`)
};

const it_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anteprima della fonte`)
};

const ru_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный просмотр исходного кода`)
};

const es_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista previa de la fuente`)
};

const zh_cn2_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源预览`)
};

const ja_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソースプレビュー`)
};

const hi_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत पूर्वावलोकन`)
};

const pt_pt2_plain_text_import_source_preview_label = /** @type {(inputs: Plain_Text_Import_Source_Preview_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-visualização da fonte`)
};

/**
* | output |
* | --- |
* | "Source Preview" |
*
* @param {Plain_Text_Import_Source_Preview_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_source_preview_label = /** @type {((inputs?: Plain_Text_Import_Source_Preview_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Source_Preview_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_source_preview_label(inputs)
	if (locale === "de") return de_plain_text_import_source_preview_label(inputs)
	if (locale === "it") return it_plain_text_import_source_preview_label(inputs)
	if (locale === "ru") return ru_plain_text_import_source_preview_label(inputs)
	if (locale === "es") return es_plain_text_import_source_preview_label(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_source_preview_label(inputs)
	if (locale === "ja") return ja_plain_text_import_source_preview_label(inputs)
	if (locale === "hi") return hi_plain_text_import_source_preview_label(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_source_preview_label(inputs)
	return en_plain_text_import_source_preview_label(inputs)
});